import { IMarginCategory } from './../models/margin-category';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';
import { IDropdownResponse } from '../models';

const baseUrl = '/api/Admin/MarginCategory';

/**
 * Simplified CRUD/network ops interface for `IBankAccount` resources.
 */
export const IMarginCategoryAPI = {
  async getAll(): Promise<IMarginCategory[]> {
    try {
      const response: AxiosResponse<IMarginCategory[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: IMarginCategory[]): Promise<IMarginCategory[]> {
    try {
      const response: AxiosResponse<IMarginCategory[]> = await authFetch.post(baseUrl, upsertData);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(businessUnitId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${businessUnitId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
    }
  },

  async lookup(): Promise<IDropdownResponse[]> {
    try {
      const response: AxiosResponse<IDropdownResponse[]> = await authFetch.get(`${baseUrl}/lookup`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  }
};
